import { useBrand } from '@contexts/useBrand'
import { updateDatalayer } from '@utils/helpers/tracking'

import ReactSelect from '../baseInputs/react-select'

type Obj = {
  name: string
}

type Props = {
  models: Array<Obj>
  helper?: string
  optional?: boolean
}

const MultiSelectModels = ({ models, ...rest }: Props) => {
  const name = 'model'
  const label = 'Models of interest'
  const brand = useBrand()

  const options = models.map((model) => {
    return {
      label: model.name,
      value: model.d4t4.id,
    }
  })

  const handleChange = (e) => {
    const model = e[0] || []

    if (model.length > 0) {
      updateDatalayer('model', {
        name: model?.name,
        id: model?.value,
        brand,
      })
    } else {
      updateDatalayer('model', false)
    }
  }

  return (
    <ReactSelect
      isMulti
      name={name}
      label={label}
      options={options}
      extraOnChange={handleChange}
      {...rest}
    />
  )
}

export default MultiSelectModels
